import { render, staticRenderFns } from "./hotConcept.vue?vue&type=template&id=4f4c1aea&scoped=true&"
import script from "./hotConcept.vue?vue&type=script&lang=js&"
export * from "./hotConcept.vue?vue&type=script&lang=js&"
import style0 from "./hotConcept.vue?vue&type=style&index=0&id=4f4c1aea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4c1aea",
  null
  
)

export default component.exports